import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  Box,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import {
  Language,
  Check
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface LanguageOption {
  code: string;
  name: string;
  flag: string;
}

const languages: LanguageOption[] = [
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'en', name: 'English', flag: '🇺🇸' }
];

const LanguageSwitch: React.FC = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode: string) => {
    console.log('切换语言到:', languageCode);
    i18n.changeLanguage(languageCode);
    console.log('当前语言:', i18n.language);
    handleClose();
  };

  return (
    <Box>
      <Button
        startIcon={<Language />}
        onClick={handleClick}
        color="inherit"
        sx={{
          minWidth: 'auto',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <span>{currentLanguage.flag}</span>
          <span>{currentLanguage.name}</span>
        </Box>
      </Button>
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: 150,
            mt: 1
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={i18n.language === language.code}
            sx={{
              py: 1,
              px: 2
            }}
          >
            <ListItemIcon sx={{ minWidth: '32px !important' }}>
              {i18n.language === language.code ? (
                <Check fontSize="small" color="primary" />
              ) : (
                <span style={{ fontSize: '16px' }}>{language.flag}</span>
              )}
            </ListItemIcon>
            <ListItemText 
              primary={language.name}
              sx={{ 
                '& .MuiListItemText-primary': { 
                  fontSize: '14px',
                  fontWeight: i18n.language === language.code ? 600 : 400
                }
              }}
            />
          </MenuItem>
        ))}
        
        <Divider sx={{ my: 1 }} />
        
        <MenuItem disabled sx={{ py: 0.5, px: 2 }}>
          <ListItemText 
            primary="Language / 语言"
            sx={{ 
              '& .MuiListItemText-primary': { 
                fontSize: '12px',
                color: 'text.secondary',
                textAlign: 'center'
              }
            }}
          />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LanguageSwitch;
